import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedReactTable from "components/shared/reactTable";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import UnstableZonesForm from "./form";

class UnstableZones extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({ value, row: { original } }) => (
                    <div
                        className="link"
                        onClick={() =>
                            this.props.modal({
                                title: "Изменение зоны",
                                name: "default",
                                windowMod: "wide",
                                CustomBody: (props) => (
                                    <UnstableZonesForm
                                        {...props}
                                        data={{
                                            ...original,
                                            coordinates: original.coordinates.map((item) => [...item].reverse()),
                                        }}
                                        mergeParams={this.props.mergeParams}
                                    />
                                ),
                            })
                        }
                    >
                        {value}
                    </div>
                ),
            },
        ];
    }

    renderCreateButton = () => {
        const { modal, mergeParams } = this.props;

        const props = {
            className: "btn btn-brand btn-sm",
            onClick: () =>
                modal({
                    title: "Добавление зоны",
                    name: "default",
                    windowMod: "wide",
                    CustomBody: (props) => <UnstableZonesForm {...props} mergeParams={mergeParams} />,
                }),
        };
        return <div {...props}>Добавить зону</div>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className="page-book__list book-list list">
                        {this.renderHead()}
                        <div className="container-fluid my-2">{this.renderActions()}</div>
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(UnstableZones, "unstable-zones");
